import { LANGUAGES } from "@/src/constants/other";
import AOS from "aos";
import "aos/dist/aos.css";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import About1 from "../../Assets/Images/Aboutus/about1.png";
import About2 from "../../Assets/Images/Aboutus/about2.svg";
import About22 from "../../Assets/Images/Aboutus/about22.svg";
import About3 from "../../Assets/Images/Aboutus/about3.svg";
import About33 from "../../Assets/Images/Aboutus/about33.svg";
import About4 from "../../Assets/Images/Aboutus/about4.svg";
import About44 from "../../Assets/Images/Aboutus/about44.svg";
import About5 from "../../Assets/Images/Aboutus/about5.svg";
import About55 from "../../Assets/Images/Aboutus/about55.svg";
import About6 from "../../Assets/Images/Aboutus/about6.svg";
import About7 from "../../Assets/Images/Aboutus/about7.svg";
import About8 from "../../Assets/Images/Aboutus/about8.png";
import About9 from "../../Assets/Images/Aboutus/about9.png";
import But from "../../Assets/Images/Aboutus/but.svg";
import core1 from "../../Assets/Images/Aboutus/core1.png";
import core2 from "../../Assets/Images/Aboutus/core2.png";
import core3 from "../../Assets/Images/Aboutus/core3.png";
import core4 from "../../Assets/Images/Aboutus/core4.png";
import core5 from "../../Assets/Images/Aboutus/core5.png";
import re1 from "../../Assets/Images/Aboutus/re1.png";
import re2 from "../../Assets/Images/Aboutus/re2.png";
import QuoteBlue from "../../Assets/Images/Icons/quote-blue.svg";
import Footer from "../Footer/Footer.presenter";
import Infomation from "../Infomation/Infomation.presenter";
import Menu from "../Menu/Menu.presenter";
import styles from "./About.module.scss";

const AboutPresenter = () => {
  const { t, i18n } = useTranslation(["translation"]);
  useEffect(() => {
    AOS.init();
  }, []);

  const [popUp, setPopUp] = useState(false);

  return (
    <>
      <main>
        <Menu />

        {!!popUp && (
          <div className={styles.about__mainVideo}>
            <div
              className={styles.about__marsk}
              onClick={() => setPopUp(!popUp)}
            ></div>
            <div className={styles.about__video}>
              <iframe
                src="https://www.youtube.com/embed/vR_1zDHTn5Y?autoplay=1"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; mute"
                allowFullScreen
                className="video-ytb"
              ></iframe>
            </div>
          </div>
        )}

        <div className={styles.about}>
          <section className={styles.about__banner}>
            <div className={styles.about__banner__container}>
              <div className={styles.about__banner__container__list}>
                <div
                  className={styles.about__banner__container__list__left}
                  data-aos="fade-left"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-back"
                  data-aos-offset="30"
                >
                  <h2>
                    {t("WE_CREATE_TRUE_VALUE")}
                    <h2 className="text-blue inline"> {t("FROM")}</h2>
                    <h2 className="text-blue">{t("TECHNOLOGY_INNOVATION")}</h2>
                  </h2>
                </div>
                <div
                  className={styles.about__banner__container__list__right}
                  data-aos="fade-right"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-back"
                  data-aos-offset="50"
                >
                  <Image src={About1} alt="" />
                  <div
                    className={
                      styles.about__banner__container__list__right__but
                    }
                    onClick={() => setPopUp(!popUp)}
                  >
                    <Image src={But} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.about__content}>
            <div className={styles.about__content__container}>
              <div className={styles.about__content__container__list}>
                <div className={styles.about__content__container__list__quote}>
                  <Image src={QuoteBlue} alt="" />
                </div>
                <div
                  className={styles.about__content__container__list__item}
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-back"
                  data-aos-offset="50"
                >
                  <h2>{t("WHO_WE_ARE")}</h2>
                  <p>{t("ET_HAS_MANY_YEAR")}</p>
                </div>
                <div
                  className={styles.about__content__container__list__item}
                  data-aos="fade-down"
                  data-aos-duration="1500"
                  data-aos-easing="ease-out-back"
                  data-aos-offset="50"
                >
                  <div
                    className={
                      styles.about__content__container__list__item__icon1
                    }
                  >
                    <Image src={About6} alt="" />
                  </div>
                  <div
                    className={
                      styles.about__content__container__list__item__icon2
                    }
                  >
                    <Image src={About7} alt="" />
                  </div>
                  <div
                    className={
                      styles.about__content__container__list__item__images
                    }
                  >
                    <div
                      className={
                        styles.about__content__container__list__item__images__image1
                      }
                    >
                      {i18n.language === LANGUAGES.en ? (
                        <Image src={About2} alt="" />
                      ) : (
                        <Image src={About22} alt="" />
                      )}
                    </div>
                    <div
                      className={
                        styles.about__content__container__list__item__images__image2
                      }
                    >
                      {i18n.language === LANGUAGES.en ? (
                        <Image src={About3} alt="" />
                      ) : (
                        <Image src={About33} alt="" />
                      )}
                    </div>
                    <div
                      className={
                        styles.about__content__container__list__item__images__image3
                      }
                    >
                      {i18n.language === LANGUAGES.en ? (
                        <Image src={About4} alt="" />
                      ) : (
                        <Image src={About44} alt="" />
                      )}
                    </div>
                    <div
                      className={
                        styles.about__content__container__list__item__images__image4
                      }
                    >
                      {i18n.language === LANGUAGES.en ? (
                        <Image src={About5} alt="" />
                      ) : (
                        <Image src={About55} alt="" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className={styles.about__mission}>
            <div className={styles.about__mission__container}>
              <div className={styles.about__mission__container__list}>
                <div className={styles.about__mission__container__list__item}>
                  <h2>{t("MISSION")}</h2>
                  <p>{t("OUR_MISSION_IS")}</p>
                </div>
                <div className={styles.about__mission__container__list__item}>
                  <Image src={About8} alt="" />
                </div>
              </div>
              <div className={styles.about__mission__container__list2}>
                <div className={styles.about__mission__container__list2__item}>
                  <Image src={About9} alt="" />
                </div>
                <div className={styles.about__mission__container__list2__item}>
                  <h2> {t("VISSION")}</h2>
                  <p>{t("OUR_VISSION_IS")}</p>
                </div>
              </div>
            </div>
          </section>

          <section className={styles.about__core}>
            <div className={styles.about__core__container}>
              <div className={styles.about__core__container__list}>
                <div className={styles.about__core__container__list__item1}>
                  <div
                    className={styles.about__core__container__list__item1__text}
                  >
                    <h3>{t("CORE_VALUE")}</h3>
                    <p className="text-white">{t("WE_BUILT")}</p>
                  </div>
                  <div>
                    <div
                      className={
                        styles.about__core__container__list__item1__re1
                      }
                    >
                      <Image src={re1} alt="" />
                    </div>
                    <div
                      className={
                        styles.about__core__container__list__item1__re2
                      }
                    >
                      <Image src={re2} alt="" />
                    </div>
                  </div>
                </div>
                <div className={styles.about__core__container__list__item}>
                  <div
                    className={styles.about__core__container__list__item__img}
                  >
                    <Image src={core1} alt="" />
                  </div>
                  <div>
                    <h2>{t("SUSTAINABLE_GROWTH")}</h2>
                    <p>{t("SUSTAINABLE_GROWTH1")}</p>
                  </div>
                </div>
                <div className={styles.about__core__container__list__item}>
                  <div
                    className={styles.about__core__container__list__item__img}
                  >
                    <Image src={core2} alt="" />
                  </div>
                  <div
                    className={styles.about__core__container__list__item__img}
                  >
                    <h2>{t("SUSTAINABLE_GROWTH2")}</h2>
                    <p>{t("SUSTAINABLE_GROWTH3")}</p>
                  </div>
                </div>
                <div className={styles.about__core__container__list__item}>
                  <div
                    className={styles.about__core__container__list__item__img}
                  >
                    <Image src={core3} alt="" />
                  </div>
                  <div>
                    <h2>{t("SUSTAINABLE_GROWTH4")}</h2>
                    <p>{t("SUSTAINABLE_GROWTH5")}</p>
                  </div>
                </div>
                <div className={styles.about__core__container__list__item}>
                  <div
                    className={styles.about__core__container__list__item__img}
                  >
                    <Image src={core4} alt="" />
                  </div>
                  <div>
                    <h2>{t("SUSTAINABLE_GROWTH6")}</h2>
                    <p>{t("SUSTAINABLE_GROWTH7")}</p>
                  </div>
                </div>
                <div className={styles.about__core__container__list__item}>
                  <div
                    className={styles.about__core__container__list__item__img}
                  >
                    <Image src={core5} alt="" />
                  </div>
                  <div>
                    <h2>{t("SUSTAINABLE_GROWTH8")}</h2>
                    <p>{t("SUSTAINABLE_GROWTH9")}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Infomation />
      </main>

      <Footer />
    </>
  );
};

export default AboutPresenter;
